<template>
    <div class="footer-content">
        <div class="top">
            <div class="right-content">
                <div class="title">หน้า</div>
                <div class="content" style="text-wrap: nowrap;">
                    <div class="page" @click="handleClick('/')">
                        หน้าแรก
                    </div>
                    <div class="page" @click="handleClick('/service')">
                        บริการ
                    </div>
                    <div class="page" @click="handleClick('/about')">
                        เกี่ยวกับเรา
                    </div>
                    <div class="page" @click="handleClick('/contact')">
                        ติดต่อเรา
                    </div>
                </div>
            </div>
            <div class="right-content">
                <div class="title">ติดต่อเรา</div>
                <div class="content">
                    <div class="page" v-for="item in list" :key="item.index">
                        <img :src="require('@/assets/footerIcon' + item.index + '.webp')" alt="">
                        {{ item.content }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom">
        Copyright 2024 © Thai LoanTech Platforms Company Limited All rights reserved
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const handleClick = (path) => {
    router.push(path);
    window.scrollTo(0, 0);
};
const list = [
    {
        content: "55/4 หมู่ที่ 9 ตำบลบ้านไผ่ อำเภอลี้ จำหวัดลำพูน",
        index: 1,
    },
    {
        content: "+66 0994677115",
        index: 2,
    },
    {
        content: "platform@thai-loantech-platforms.com",
        index: 3,
    },
];
</script>
<style lang="less" scoped>
.footer-content {
    padding: 32px 329px 28px;
    background-color: #024C5A;
}

.top {
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;

    .title {
        font-weight: bold;
        font-size: 15px;
        color: #FFFFFF;
        line-height: 15px;
        text-wrap: nowrap;
    }

    .content {
        display: flex;
        flex-direction: column;
        margin-top: 15px;
        font-weight: 500;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
        justify-content: space-around;


        .page {
            cursor: pointer;
            margin-bottom: 13px;
            display: flex;
            align-items: center;

            img {
                width: 26px;
                object-fit: cover;
                margin-right: 6px;
            }
        }
    }
}

.bottom {
    padding: 18px 0;
    font-weight: 500;
    font-size: 15px;
    color: #D7D7D7;
    line-height: 15px;
    background-color: #00333D;
    text-align: center;
}
</style>